import { render, staticRenderFns } from "./MillageEdit.vue?vue&type=template&id=6f27f03f&"
import script from "./MillageEdit.vue?vue&type=script&lang=js&"
export * from "./MillageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports